import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { FullPageLoader } from "@/components/Loader";

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const m = window.location.hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    window.history.replaceState(null, "", window.location.pathname);
    if (!sid) {
      navigate("/", { replace: true });
      return;
    }
    api
      .post("/auth/session", { session_id: sid })
      .then(({ data }) => {
        setUser(data);
        navigate(data.onboarding_complete ? "/dashboard" : "/onboarding", { replace: true });
      })
      .catch(() => {
        toast.error("Sign-in failed. Please try again.");
        navigate("/", { replace: true });
      });
  }, [navigate, setUser]);

  return <FullPageLoader label="Signing you in…" />;
};
